import { render } from "./LicenseCardLarge.vue?vue&type=template&id=33fb63a0"
import script from "./LicenseCardLarge.vue?vue&type=script&lang=js"
export * from "./LicenseCardLarge.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__